import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WebSocket from '../WebSocket';
import AccountingWebSocket from '../pages/AccountingPages/AccountingWebSocket';
import { BackendWebSocketContext } from '../BackendWebSocket';
import { useCurrentCompany, useIsPsd2ObAvailable } from '../../hooks';
import { openBankingActions } from '../../state/actions/openBanking.actions';
import { userActions } from '../../state/actions/user.actions';
import {
  backendWebsocketActionsConstants,
  openBankingWebsocketActionsConstants,
} from '../../constants';

const AppWebSocketManager = () => {
  const dispatch = useDispatch();
  const { dispatchMessage } = useContext(BackendWebSocketContext);

  const notificationCount = useSelector((state) => state.user.notificationCount);

  const currentCompany = useCurrentCompany();
  const companyId = currentCompany?.id;

  const isPsd2ObAvailable = useIsPsd2ObAvailable();
  const [obWsActive, setObWsActive] = useState(false);

  useEffect(() => {
    if (isPsd2ObAvailable && companyId) setObWsActive(true);
  }, [isPsd2ObAvailable, companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpdateNotificationCounter = (data) => {
    const { read_count = 0, unread_count = 0 } = data;

    dispatch(userActions.updateNotificationsCount({
      read: read_count,
      unread: unread_count,
    }));

    if (notificationCount?.unread !== unread_count) {
      dispatch(userActions.getNotificationList());
    }
  };

  const handleConnectionActive = (data) => {
    const { connection_id } = data?.action_data || {};
    if (connection_id) dispatch(openBankingActions.getConnection({ connectionId: connection_id }));
  };

  const handleRefreshAccountsDone = (data) => {
    const { connection_id, account } = data?.action_data || {};
    dispatch(openBankingActions.markAccountsRefreshed({connectionId: connection_id}));
    if (account) dispatch(openBankingActions.setAccount(account));
  };

  const handleMessage = (data) => {
    const { action } = data || {};
    ({
      [backendWebsocketActionsConstants.NOTIFICATION_COUNTER_UPDATE]: handleUpdateNotificationCounter,
      [openBankingWebsocketActionsConstants.CONNECTION_ACTIVE]: handleConnectionActive,
      [openBankingWebsocketActionsConstants.REFRESH_ACCOUNTS_DONE]: handleRefreshAccountsDone,
    })[action]?.(data);
    dispatchMessage(data);
  };

  return (
    <>
      {companyId && <WebSocket key={companyId} onMessage={handleMessage} />}
      {obWsActive && <WebSocket key={companyId} variant='openBanking' onMessage={handleMessage} />}
      <AccountingWebSocket />
    </>
  );
};

export default AppWebSocketManager;
